import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import { Textarea } from "../../ui/textarea";
import { Upload } from "lucide-react";
import { resolveMediaUrl } from "../../../lib/api";

export const ServiceEditItem = ({ service, onDescriptionChange, onImageChange, uploadingKey, onUpload }) => (
  <div className="border-t pt-4 space-y-2" data-testid={`admin-service-edit-${service.key}`}>
    <p className="text-sm font-medium">{service.label}</p>
    <Label>Descripción</Label>
    <Textarea data-testid={`admin-service-description-${service.key}`} value={service.description} onChange={onDescriptionChange} />
    <Label>Foto del servicio</Label>
    <div className="flex items-center gap-3">
      {service.image && <img src={resolveMediaUrl(service.image)} alt={service.label} className="h-14 w-20 object-cover rounded" />}
      <Input data-testid={`admin-service-image-${service.key}`} value={service.image} onChange={onImageChange} placeholder="URL de la imagen" />
      <label data-testid={`admin-service-upload-label-${service.key}`} className="shrink-0 flex items-center gap-1 border rounded px-3 py-2 text-xs cursor-pointer hover:bg-secondary/50">
        <Upload size={14} /> {uploadingKey === service.key ? "Subiendo..." : "Subir"}
        <input
          data-testid={`admin-service-upload-input-${service.key}`}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={onUpload}
          disabled={uploadingKey === service.key}
        />
      </label>
    </div>
  </div>
);
